var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1527 10.8999L12.1371 19.9156C10.0869 21.9658 6.76275 21.9658 4.71249 19.9156C2.66224 17.8653 2.66224 14.5412 4.71249 12.4909L13.7281 3.47532C15.0949 2.10849 17.311 2.10849 18.6779 3.47532C20.0447 4.84216 20.0447 7.05823 18.6779 8.42507L10.0158 17.0871C9.33238 17.7705 8.22434 17.7705 7.54092 17.0871C6.8575 16.4037 6.8575 15.2957 7.54092 14.6123L15.1423 7.01086",
    stroke: "#2B3D4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.9d3c8cdbd4e3b451987e07b9b59d0e30.svg";
export { ForwardRef as ReactComponent };